import React, { useEffect, useMemo, useState } from 'react';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import Footer from '../components/layout/footer';
import ExhibitorCard from '../components/common/exhibitorCard';
import './explore.css';
import Btn from '../components/common/btn';
import { supabase } from '../supabase';

const Explore = () => {
  const [exhibitors, setExhibitors] = useState([]);
  const [search, setSearch] = useState('');
  const [audience, setAudience] = useState('');
  const [priceRange, setPriceRange] = useState('');
  const [hall, setHall] = useState('');
  const [language, setLanguage] = useState('');

  const loadExhibitors = async () => {
    const { data, error } = await supabase
      .from('exhibitors')
      .select('*')
      .eq('status', 'Approved')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error loading exhibitors:', error);
      return;
    }

    setExhibitors(data || []);
  };

  useEffect(() => {
    loadExhibitors();

    const channel = supabase
      .channel('frontend_exhibitors_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'exhibitors',
        },
        () => loadExhibitors()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const filteredExhibitors = useMemo(() => {
    return exhibitors.filter((exhibitor) => {
      const matchesSearch =
        exhibitor.name?.toLowerCase().includes(search.toLowerCase()) ||
        exhibitor.description?.toLowerCase().includes(search.toLowerCase()) ||
        exhibitor.category?.toLowerCase().includes(search.toLowerCase());

      const matchesAudience = audience ? exhibitor.audience === audience : true;
      const matchesPrice = priceRange ? exhibitor.price_range === priceRange : true;
      const matchesHall = hall ? exhibitor.hall === hall : true;
      const matchesLanguage = language ? exhibitor.language === language : true;

      return matchesSearch && matchesAudience && matchesPrice && matchesHall && matchesLanguage;
    });
  }, [exhibitors, search, audience, priceRange, hall, language]);

  return (
    <>
      <ScrollHideHeader />
      <main>
        <div className="bgDecor"></div>

        <section className="exploreSec">
          <aside className="exploreFilter">
            <div className="filterHeader">
              <h4>Filters</h4>
              <button
                className="clearFiltersBtn"
                onClick={() => {
                  setAudience('');
                  setPriceRange('');
                  setHall('');
                  setLanguage('');
                }}
              >
                Clear All
              </button>
            </div>

            <div className="filterGroup">
              <h5>Target Audience</h5>
              {['Kids', 'Young Adults', 'Adults'].map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    checked={audience === item}
                    onChange={() => setAudience(audience === item ? '' : item)}
                  />
                  {item}
                </label>
              ))}
            </div>

            <div className="filterGroup">
              <h5>Price Range</h5>
              {['Budget', 'Mid-range', 'Premium'].map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    checked={priceRange === item}
                    onChange={() => setPriceRange(priceRange === item ? '' : item)}
                  />
                  {item}
                </label>
              ))}
            </div>

            <div className="filterGroup">
              <h5>Location</h5>
              {['Hall 1', 'Hall 2', 'Hall 3', 'Hall 4'].map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    checked={hall === item}
                    onChange={() => setHall(hall === item ? '' : item)}
                  />
                  {item}
                </label>
              ))}
            </div>

            <div className="filterGroup">
              <h5>Language</h5>
              {['Arabic', 'English', 'French', 'Other'].map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    checked={language === item}
                    onChange={() => setLanguage(language === item ? '' : item)}
                  />
                  {item}
                </label>
              ))}
            </div>
          </aside>

          <div className="exhibitorsSearch">
            <input
              type="text"
              placeholder="Search exhibitors..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="displayNoneExplore">
              <Btn btnText="Filter" btnStyle="filterBtn" btnIcon="filterIcon" />
            </div>

            <div className="exhibitors">
              {filteredExhibitors.map((exhibitor) => (
                <ExhibitorCard
  key={exhibitor.id}
  exhibitorName={exhibitor.name}
  exhibitorDesc={exhibitor.description}
  exhibitorCategory1={exhibitor.language}
  exhibitorCategory2={exhibitor.category}
  exhibitorCategory3={exhibitor.audience}
  exhibitorLocation={`${exhibitor.hall} - Booth ${exhibitor.booth}`}
  exhibitorLogo={exhibitor.logo_url}
/>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};

export default Explore;